/**
 * TimelineSuccessionToggle Component
 *
 * Toggles visibility of crop succession sub-rows on the timeline.
 * Disabled when no crops in the current view have succession records.
 */

import React from 'react'
import { Repeat } from '@mui/icons-material'
import { TpToggleButton } from '~/components/tp-toggle-button'
import {
  useTimelineContextDispatch,
  setShowSuccessions,
  setExpandedSuccessionKey,
} from '../../context/timeline-context'
import { useTimelineStaticContext } from '../../context/timeline-static-context'
import { Stack, useMediaQuery, useTheme } from '@mui/material'
import { TpControlTooltip } from '../../../../../components/tp-control-tooltip'
import { CONTROLS_BREAKPOINT } from './timeline-controls-constants'
import { useFeatures } from '~/common/use-features'

export const TimelineSuccessionToggle = () => {
  const theme = useTheme()
  const isExpanded = useMediaQuery(theme.breakpoints.up(CONTROLS_BREAKPOINT))
  const { showSuccessions, successionMap } = useTimelineStaticContext()
  const dispatch = useTimelineContextDispatch()
  const { features } = useFeatures()

  const hasAnySuccessions = successionMap?.size > 0

  const handleToggle = () => {
    const next = !showSuccessions
    dispatch(setShowSuccessions({ showSuccessions: next }))
    // Clear any opened succession when hiding
    if (!next) {
      dispatch(setExpandedSuccessionKey({ expandedSuccessionKey: null }))
    }
  }

  if (!hasAnySuccessions || !features['crop_successions']) return null

  if (isExpanded) {
    return (
      <TimelineSuccessionToggleContent
        {...{ hasAnySuccessions, showSuccessions, handleToggle }}
        sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}
      />
    )
  }

  return (
    <TimelineSuccessionToggleContent {...{ hasAnySuccessions, showSuccessions, handleToggle }} />
  )
}

const TimelineSuccessionToggleContent = ({ hasAnySuccessions, showSuccessions, handleToggle, ...rest }) => {
  return (
    <TpToggleButton
      disabled={!hasAnySuccessions}
      onClick={handleToggle}
      selected={showSuccessions}
      {...rest}
    >
      <TpControlTooltip title="Successions" offsetBottom={-8}>
        <Stack>
          <Repeat sx={{ fontSize: 20 }} />
        </Stack>
      </TpControlTooltip>
    </TpToggleButton>
  )
}
